import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

async function NivelCumplimientoHallazgoIndicadorSerieDetalleService(values) {
    try {
        return await instance.Backend.post("/Indicador/NivelCumplimientoHallazgoIndicadorSerieDetalle"
            , values
            , customConfig);
    } catch (error) {
        console.log(error);
    }
}
export { NivelCumplimientoHallazgoIndicadorSerieDetalleService };